module.exports = __webpack_public_path__ + "img/page_right_bg.ea6cccfa.png";